import ShareComponent from '@/features/shareComponent';
const NewsDetail = ({ newsDetail }) => {
  return (
    <>
      {newsDetail ? (
        <div className="w-[1200px] m-[10px_auto_14px] p-[10px_20px] box-border bg-white rounded-[10px]">
          <div className="m-[15px_20px_0_20px] h-[96px] border-b border-solid border-[#f0f0f0] text-center">
            <h1 className="text-[20px] leading-[30px] text-[#333333] pt-[15px] font-bold">{newsDetail?.title}</h1>
            <p className="text-[12px] mt-[15px] text-[#999]">
              {newsDetail.shelfBeginTime && newsDetail.shelfBeginTime !== '' ? (
                <span className="mr-[20px]">{newsDetail.shelfBeginTime}</span>
              ) : (
                <span className="mr-[20px]">{newsDetail.publishTime}</span>
              )}
              <span className="mr-[20px]">阅读量：{newsDetail.readCount}</span>
              {newsDetail.source && newsDetail.source !== '' ? (
                <span className="mr-[20px]">来源：{newsDetail.source}</span>
              ) : null}
            </p>
          </div>
          <div
            className="mt-[15px] mx-[20px] [&_img]:max-w-[96%] [&_img]:mx-auto"
            dangerouslySetInnerHTML={{ __html: newsDetail.content }}
          />
          <ShareComponent />
        </div>
      ) : null}
    </>
  );
};
export default NewsDetail;
